import { z } from "zod";

import { DbEnum } from "../../../../../generated/prisma-enums";

/**
 * Phone Number Request Status Enum (Zod)
 */
export const PhoneNumberRequestStatusSchema = z.enum(DbEnum.PHONE_NUMBER_REQUEST_STATUS_VALUES);

/**
 * Phone Number Use Case Enum (Zod)
 */
export const PhoneNumberUseCaseSchema = z.enum(DbEnum.PHONE_NUMBER_USE_CASE_VALUES);

/**
 * Phone Number Request Response Schema
 *
 * Returned when fetching phone number requests.
 */
export const PhoneNumberRequestResponseSchema = z.object({
  id: z.string().uuid(),

  // Who & When (all optional since they might not be populated)
  organizationId: z.string().optional(),
  organizationName: z.string().nullish(),
  userId: z.string().optional(),
  userName: z.string().nullish(),
  userEmail: z.string().nullish(),
  createdAt: z.string().datetime().optional(),
  updatedAt: z.string().datetime().optional(),

  // Request Details (all optional/nullable)
  countryCode: z.string().optional(),
  useCase: PhoneNumberUseCaseSchema.optional(),
  justification: z.string().nullish(),
  expectedVolume: z.number().nullish(),

  // Connection context
  connectionId: z.string().uuid().nullish(),

  // Status Tracking (all optional/nullable)
  status: PhoneNumberRequestStatusSchema.optional(),
  statusChangedAt: z.string().datetime().optional(),
  statusChangedBy: z.string().nullish(),
  statusChangedByName: z.string().nullish(),

  // Admin Response (all nullable)
  adminNotes: z.string().nullish(),
  rejectionReason: z.string().nullish(),

  // Provisioning (all nullable)
  phoneNumberId: z.string().uuid().nullish(),
  phoneNumber: z.string().nullish(),
  provisionedAt: z.string().datetime().nullish(),

  // Metadata
  metadata: z.record(z.string(), z.unknown()).nullish()
});

export type PhoneNumberRequestResponse = z.infer<typeof PhoneNumberRequestResponseSchema>;

/**
 * List Response Schema
 */
export const ListPhoneNumberRequestsResponseSchema = z.object({
  requests: z.array(PhoneNumberRequestResponseSchema),
  total: z.number(),
  hasMore: z.boolean()
});

export type ListPhoneNumberRequestsResponse = z.infer<typeof ListPhoneNumberRequestsResponseSchema>;
